import { render, staticRenderFns } from "./MainFooterComponent.vue?vue&type=template&id=9d8d7aec"
import script from "./MainFooterComponent.vue?vue&type=script&lang=js"
export * from "./MainFooterComponent.vue?vue&type=script&lang=js"
import style0 from "./MainFooterComponent.vue?vue&type=style&index=0&id=9d8d7aec&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports